<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">
    <div class="layout-column flex ma-1"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <div v-bind:style="{'z-index': '4'}" class="layout-row pa-1">
        <div class="layout-row">
          <lx-btn small classes="mr-1"
                  :disabled="tableObj.loading"
                  @click="getData()"
                  icon="refresh"
                  tooltip="Ansicht aktualisieren"
                  label="Aktualisieren"
                  hide-label></lx-btn>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column lx-delivery-background pa-1" style="overflow-y: hidden;">

        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px;" :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1);" class="flex layout-column">
            <doughnut-chart
              style="height: 300px;"
              v-if="chartLoaded"
              :chartdata="chartData"
              :options="options"/>

            <v-divider v-show="chartLoaded" class="mt-5"></v-divider>

            <div class="pa-2">
              <h4>Elemente in Warteschlange</h4>

              <lx-data-table
                style="height: 200px;"
                :items="queded"
                :headers="tableObj.headers"
                :loading="tableObj.loading"
                :tableOptions="tableObj.options"
                tableName="ElementeWarteschlange">
              </lx-data-table>
            </div>

            <v-divider class="mt-5"></v-divider>

            <div class="pa-2">
              <h4>Nicht gesendete Elemente</h4>

              <lx-data-table
                style="height: 200px;"
                :items="errored"
                :headers="tableObj.headers"
                :loading="tableObj.loading"
                :tableOptions="tableObj.options"
                tableName="NichtGesendeteElemente">
              </lx-data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DoughnutChart from '../../../components/charts/DoughnutChart'

function toPieChartData (input) {
  const states = [
    { label: 'Unbekannt', color: '#777' },// 0
    { label: 'Warteschlange', color: '#00A0A0' }, // 1
    { label: 'Gesendet', color: '#00A000' },   // 2
    { label: 'Fehler', color: '#A00000' }   // 3
  ]

  let data = new Array(states.length)

  if (Array.isArray(input)) {
    input.forEach(item => {
      data[item.name] = item.count
    })
  }

  const dataset = {
    label: 'Dataset 1',
    data: data,
    backgroundColor: states.map(v => v.color)
  }

  return {
    labels: states.map(v => v.label),
    datasets: [dataset]
  }
}

export default {
  name: 'MonitoringMailQueueDetails',
  components: { DoughnutChart },
  data () {
    return {
      tableObj: {
        loading: false,
        options: {
          sortBy: ['lastname'],
          sortDesc: [false],
        },
        headers: [
          {
            text: 'Zeitstempel',
            value: 'timestamp',
            width: '200px',
            sortable: true,
            renderer: 'date'
          },
          {
            text: 'Betreff',
            value: 'subject',
            width: '500px'
          },
          {
            text: 'Empfänger',
            value: 'receivers',
            width: '300px'
          },
          {
            text: 'Zurückgehalten bis',
            value: 'locked',
            width: '200px',
            renderer: 'date'
          }
        ]
      },
      chartLoaded: false,
      chartData: null,
      errored: [],
      queded: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        stacked: false,
        interaction: {
          mode: 'index',
          intersect: false,
        },
        title: {
          display: true,
          text: 'Warteschlange der letzten 100 Tage'
        }
      }
    }
  },
  async mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.chartLoaded = false
      this.errored = []
      this.queded = []

      this.$http.get('monitoring/mailQueue')
        .then(res => {
          if (res.data) {
            this.chartData = toPieChartData(res.data)

            if (Array.isArray(res.data) && res.data.length > 0) {
              res.data.forEach(item => {
                if (item.name === 1) {
                  this.queded = item.values || []
                }

                if (item.name === 3) {
                  this.errored = item.values || []
                }
              })
            }

            setTimeout(() => {
              this.chartLoaded = true
            }, 100)
          }
        })
        .catch(this.NotifyError)
    }
  },
  watch: {
    '$route' (to) {
      if (to.name === 'MonitoringMailQueueDetails') {
        this.getData()
      }
    }
  }
}
</script>
